(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  function reveal(scope = document) {
    if (reduced.matches || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
    }), { threshold: 0.08 });
    scope.querySelectorAll('[data-bbs-reveal]:not(.bbs-reveal-ready)').forEach(el => {
      if (el.getBoundingClientRect().top < innerHeight) return;
      el.classList.add('bbs-reveal-ready'); observer.observe(el);
    });
    reduced.addEventListener('change', () => {
      if (reduced.matches) { scope.querySelectorAll('.bbs-reveal-ready').forEach(el => el.classList.add('is-visible')); observer.disconnect(); }
    }, { once: true });
  }
  function community() {
    const section = document.querySelector('[data-bbs-community]');
    if (!section) return;
    const grid = section.querySelector('[data-bbs-community-grid]');
    const seen = new Set();
    let observer;
    function collect() {
      const root = document.querySelector('#judgeme_product_reviews');
      if (!root || root.dataset.productId !== section.dataset.productId || root.dataset.shopReviews !== 'false') return;
      root.querySelectorAll('.jdgm-review-list .jm-review-item img[alt="Review Image"]').forEach(source => {
        const raw = source.getAttribute('src');
        if (!raw || seen.size >= 8) return;
        let url;
        try { url = new URL(raw); } catch { return; }
        if (url.protocol !== 'https:' || url.hostname !== 'review-images.judgeme.com') return;
        const key = url.origin + url.pathname;
        if (url.pathname.endsWith('1787415647__1787415635787-1000005744__original.jpg')) return;
        if (seen.has(key)) return;
        seen.add(key); url.searchParams.set('width', '800'); url.searchParams.set('quality', '85');
        const figure = document.createElement('figure'); figure.className = 'bbs-community-photo';
        const img = document.createElement('img'); img.alt = section.dataset.photoAlt;
        img.width = 800; img.height = 600; img.loading = 'lazy'; img.decoding = 'async';
        img.addEventListener('error', () => { figure.remove(); if (!grid.children.length) section.hidden = true; }, { once: true });
        img.src = url.href; figure.append(img); grid.append(figure); section.hidden = false;
      });
    }
    collect();
    observer = new MutationObserver(collect);
    observer.observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
    window.addEventListener('pagehide', () => observer.disconnect(), { once: true });
  }
  reveal(); community();
  document.addEventListener('shopify:section:load', event => reveal(event.target));
})();
